
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/labs",
      function () {
        return require("private-next-pages/labs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/labs"])
      });
    }
  